import React from 'react';
const volumeData = [{
  asset: 'BTC',
  volume: 45200,
  color: 'bg-brand-purple'
}, {
  asset: 'ETH',
  volume: 28700,
  color: 'bg-brand-purple/80'
}, {
  asset: 'SOL',
  volume: 12400,
  color: 'bg-brand-purple/60'
}, {
  asset: 'BNB',
  volume: 8900,
  color: 'bg-brand-purple/40'
}, {
  asset: 'USDT',
  volume: 5100,
  color: 'bg-brand-purple/20'
}];
export function TradingActivityCharts() {
  const maxVolume = Math.max(...volumeData.map(d => d.volume));
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-228">
      {/* Volume by Asset */}
      <div className="glass-border rounded-[20px] p-6" data-id="element-229">
        <h3 className="text-sm font-heading text-text-primary mb-6" data-id="element-230">
          Volume by Asset
        </h3>
        <div className="space-y-4" data-id="element-231">
          {volumeData.map(item => <div key={item.asset} className="flex items-center gap-3" data-id="element-232">
              <span className="w-10 text-xs font-label text-text-secondary" data-id="element-233">
                {item.asset}
              </span>
              <div className="flex-1 h-2 bg-background-elevated rounded-full overflow-hidden" data-id="element-234">
                <div className={`h-full rounded-full ${item.color}`} style={{
              width: `${item.volume / maxVolume * 100}%`
            }} data-id="element-235" />
              </div>
              <span className="w-16 text-right text-xs font-numbers text-text-primary" data-id="element-236">
                ${(item.volume / 1000).toFixed(1)}K
              </span>
            </div>)}
        </div>
      </div>

      {/* Trade Summary */}
      <div className="glass-border rounded-[20px] p-6 flex flex-col" data-id="element-237">
        <h3 className="text-sm font-heading text-text-primary mb-6" data-id="element-238">
          Trade Summary
        </h3>

        {/* Buy/Sell Donut - simple visual */}
        <div className="flex items-center gap-6 mb-6" data-id="element-239">
          <div className="relative w-20 h-20" data-id="element-240">
            <svg viewBox="0 0 36 36" className="w-full h-full -rotate-90" data-id="element-241">
              <circle cx="18" cy="18" r="15.9" fill="none" stroke="#252535" strokeWidth="3" data-id="element-242" />
              <circle cx="18" cy="18" r="15.9" fill="none" stroke="#00C87F" strokeWidth="3" strokeDasharray="62 38" strokeDashoffset="0" className="transition-all duration-700" data-id="element-243" />
              <circle cx="18" cy="18" r="15.9" fill="none" stroke="#E85D75" strokeWidth="3" strokeDasharray="38 62" strokeDashoffset="-62" className="transition-all duration-700" data-id="element-244" />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-245">
              <span className="text-xs font-numbers text-text-primary" data-id="element-246">
                146
              </span>
            </div>
          </div>
          <div className="space-y-2" data-id="element-247">
            <div className="flex items-center gap-2" data-id="element-248">
              <div className="w-2 h-2 rounded-full bg-success" data-id="element-249" />
              <span className="text-xs text-text-secondary" data-id="element-250">Buy orders</span>
              <span className="text-xs font-numbers text-text-primary ml-auto" data-id="element-251">
                91 (62%)
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-252">
              <div className="w-2 h-2 rounded-full bg-danger" data-id="element-253" />
              <span className="text-xs text-text-secondary" data-id="element-254">Sell orders</span>
              <span className="text-xs font-numbers text-text-primary ml-auto" data-id="element-255">
                55 (38%)
              </span>
            </div>
          </div>
        </div>

        {/* Quick stats */}
        <div className="grid grid-cols-2 gap-4 mt-auto" data-id="element-256">
          <div className="bg-background-elevated/50 rounded-xl p-3" data-id="element-257">
            <div className="text-[10px] font-label text-text-tertiary uppercase mb-1" data-id="element-258">
              Avg Trade Size
            </div>
            <div className="text-sm font-numbers text-text-primary" data-id="element-259">$687</div>
          </div>
          <div className="bg-background-elevated/50 rounded-xl p-3" data-id="element-260">
            <div className="text-[10px] font-label text-text-tertiary uppercase mb-1" data-id="element-261">
              Total Volume
            </div>
            <div className="text-sm font-numbers text-text-primary" data-id="element-262">
              $100.3K
            </div>
          </div>
          <div className="bg-background-elevated/50 rounded-xl p-3" data-id="element-263">
            <div className="text-[10px] font-label text-text-tertiary uppercase mb-1" data-id="element-264">
              Most Traded
            </div>
            <div className="text-sm font-numbers text-text-primary" data-id="element-265">
              BTC/USDT
            </div>
          </div>
          <div className="bg-background-elevated/50 rounded-xl p-3" data-id="element-266">
            <div className="text-[10px] font-label text-text-tertiary uppercase mb-1" data-id="element-267">
              Last Trade
            </div>
            <div className="text-sm font-numbers text-text-primary" data-id="element-268">2h ago</div>
          </div>
        </div>
      </div>
    </div>;
}